<template>
  <div v-if="shipping">
    <div class="title mb-2 text-uppercase">
      {{ $t("transaction_detail_shipping.title") }}
    </div>
    <div
      v-for="(carrier_delivery_snapshot, index) in shipping.carriers_delivery"
      :key="index"
    >
      <div v-if="carrier_delivery_snapshot.carrier_name">
        {{ $_.get(carrier_delivery_snapshot, 'carrier_name', '') }}
      </div>
      <div v-else>
        {{ $_.get(carrier_delivery_snapshot, 'carrier_delivery.carrier.name', '') }}
      </div>
      <div>
        {{ $_.get(carrier_delivery_snapshot, 'external_service_product_name', '') }}
      </div>
      <div v-if="carrier_delivery_snapshot.carrier_type == 0">
        {{ $t("transaction_detail_shipping.method_pickup") }}
      </div>
      <div v-if="carrier_delivery_snapshot.carrier_type == 1">
        {{ $t("transaction_detail_shipping.method_shipping") }}
      </div>

    </div>
  </div>
</template>


<script>
export default {
  name: "transaction-detail-payment",
  props: {
    shipping: {
      type: Object,
      default: undefined,
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_shipping: {
          title: "Shipping method",
          method_pickup: "Method: Pickup",
          method_shipping: "Method: Shpping",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
